module.exports = __webpack_public_path__ + "static/media/GemG.1c5e4b7b.png";